import { useLocalLogic } from "~/context/LocalLogicProvider";
import { useQuery } from "@tanstack/react-query";

import { schoolsKeys, schoolsResponse } from "~/features/schools";

import type { Schools } from "@local-logic/client";

type Options = {
  lat?: number;
  lng?: number;
  limit?: number;
  // Include is used to specify whether the query should run or not
  // And also to make this hoook look like the usePois hook which has a similar structure
  include?: (keyof Schools)[];
  radius?: number;
  attemptMinimum?: number;
  includeCatchments?: boolean;
};

export function useSchools({
  lat,
  lng,
  include,
  radius = 2000,
  // 30 is the default limit and maximum number of schools returned by the API
  limit = 30,
  attemptMinimum,
  includeCatchments = false,
}: Options) {
  const { client } = useLocalLogic();

  const options = {
    lat,
    lng,
    limit,
    radius,
    attemptMinimum,
    include_catchments: includeCatchments,
  };

  return useQuery({
    queryKey: schoolsKeys.list(options),
    queryFn: async () =>
      client.getSchools(options as unknown as schoolsResponse),
    staleTime: Infinity,
    enabled: !!options && !!include?.length && !!options.lat && !!options.lng,
  });
}
